import React from "react";
import { CTAButton, SectionLabel, Reveal } from "@/lib/uiHelpers";
import { EQUIPMENT } from "@/constants/landingCopy";
import { Check, BatteryCharging } from "lucide-react";

function EquipmentCard({ item }) {
  return (
    <div
      className="h-full flex flex-col rounded-2xl bg-white overflow-hidden"
      style={{ boxShadow: "0 18px 44px -28px rgba(26,43,74,0.3)", border: "1px solid #ece7dc" }}
    >
      <div
        className="relative flex items-center justify-center"
        style={{ background: "linear-gradient(135deg, #f7f4ee 0%, #eee7d8 100%)", height: "260px" }}
      >
        <img
          src={item.image}
          alt={`${item.name} home battery system`}
          loading="lazy"
          className={item.contain ? "max-h-[230px] w-auto object-contain" : "w-full h-full object-cover"}
        />
        <span
          className="absolute top-4 left-4 font-head rounded-full px-3 py-1 text-xs font-extrabold uppercase"
          style={{ background: "#1A2B4A", color: "#F5A623", letterSpacing: "0.06em" }}
        >
          {item.tag}
        </span>
      </div>

      <div className="p-7 flex flex-col flex-1">
        <h3 className="font-head font-extrabold text-2xl flex items-center gap-2" style={{ color: "#1A2B4A" }}>
          <BatteryCharging size={22} style={{ color: "#27AE60" }} /> {item.name}
        </h3>
        <ul className="mt-4 space-y-3 flex-1">
          {item.points.map((p) => (
            <li key={p} className="flex items-start gap-2.5">
              <span
                className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
                style={{ background: "rgba(39,174,96,0.16)" }}
              >
                <Check size={13} strokeWidth={3} style={{ color: "#27AE60" }} />
              </span>
              <span className="font-body text-sm md:text-base" style={{ color: "#2C3E50" }}>{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Equipment() {
  return (
    <section className="section-pad" style={{ backgroundColor: "#F4F0E8" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>Premium Equipment</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl" style={{ color: "#1A2B4A" }}>
            Battery Backup Built for the Island
          </h2>
          <p className="font-body mt-4 text-base md:text-lg" style={{ color: "#7F8C8D" }}>
            On Maui, the grid goes down &mdash; storms, outages, and remote lines are a fact of
            island life. Add battery storage and keep your home powered. We install today&apos;s
            best home batteries.
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6 items-stretch">
          {EQUIPMENT.map((item, i) => (
            <Reveal key={item.name} delay={i * 0.1}>
              <EquipmentCard item={item} />
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton testId="equipment-cta" variant="gold" className="w-full sm:w-auto">
            &rarr; Ask About Battery Backup &mdash; Book My Call
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
